import React, { useEffect } from 'react';
import Navbar from '../../components/Navbar';
import Footer from '../../components/Footer';
import './AdvancedHospitalChennai.css';

const AdvancedHospitalChennai = () => {
  useEffect(() => {
    window.scrollTo(0, 0);

    const schema = {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "Organization",
          "@id": "https://www.primerehabindustries.in/#organization",
          "name": "Prime Rehab Industries",
          "url": "https://www.primerehabindustries.in",
          "logo": "https://www.primerehabindustries.in/logo.png",
          "telephone": "+919994351947",
          "email": "primerehaboffl@gmail.com",
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Chennai",
            "addressRegion": "Tamil Nadu",
            "addressCountry": "IN"
          }
        },
        {
          "@type": "LocalBusiness",
          "@id": "https://www.primerehabindustries.in/#localbusiness",
          "name": "Prime Rehab Industries",
          "parentOrganization": { "@id": "https://www.primerehabindustries.in/#organization" },
          "url": "https://www.primerehabindustries.in",
          "telephone": "+919994351947",
          "email": "primerehaboffl@gmail.com",
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Chennai",
            "addressRegion": "Tamil Nadu",
            "addressCountry": "IN"
          },
          "areaServed": "Tamil Nadu, India",
          "priceRange": "Contact for pricing"
        },
        {
          "@type": "Product",
          "name": "Advanced Hospital and Physiotherapy Equipment",
          "description": "Prime Rehab Industries manufactures hospital-grade physiotherapy and rehabilitation equipment in Chennai including spinal traction tables, motorised treatment tables, tilt tables, and unweighing systems.",
          "brand": { "@id": "https://www.primerehabindustries.in/#organization" },
          "manufacturer": { "@id": "https://www.primerehabindustries.in/#organization" },
          "aggregateRating": {
            "@type": "AggregateRating",
            "ratingValue": "4.9",
            "reviewCount": "155",
            "bestRating": "5"
          },
          "review": [
            {
              "@type": "Review",
              "author": { "@type": "Person", "name": "Arjun Krishnaswamy" },
              "reviewRating": { "@type": "Rating", "ratingValue": "5", "bestRating": "5" },
              "datePublished": "2025-05-22",
              "reviewBody": "We equipped our hospital physiotherapy department with treatment tables and a traction unit from Prime Rehab. The motorised height adjustment is something our therapists rely on daily."
            },
            {
              "@type": "Review",
              "author": { "@type": "Person", "name": "Dr. Anitha Mohan" },
              "reviewRating": { "@type": "Rating", "ratingValue": "5", "bestRating": "5" },
              "datePublished": "2025-10-08",
              "reviewBody": "The Spinethera DTS Table we ordered for our orthopaedic unit has been outstanding. It handles high patient throughput well and the traction lock mechanism is smooth and reliable."
            }
          ]
        },
        {
          "@type": "FAQPage",
          "mainEntity": [
            {
              "@type": "Question",
              "name": "What makes physiotherapy equipment suitable for hospital use compared to clinic use?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Hospital-grade physiotherapy equipment must handle significantly higher patient throughput. This demands heavier frame construction, higher-rated electric actuators with greater duty cycles, and upholstery that can withstand frequent clinical disinfection. Prime Rehab Industries manufactures all equipment to these hospital clinical demands."
              }
            },
            {
              "@type": "Question",
              "name": "Can Prime Rehab Industries supply rehabilitation equipment for a complete hospital department setup?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Yes. Prime Rehab Industries regularly supplies complete department setups for hospital rehabilitation units, covering treatment tables, traction tables, tilt tables, Bobath tables, and unweighing systems in a single order."
              }
            }
          ]
        },
        {
          "@type": "BreadcrumbList",
          "itemListElement": [
            {
              "@type": "ListItem",
              "position": 1,
              "name": "Home",
              "item": "https://www.primerehabindustries.in"
            },
            {
              "@type": "ListItem",
              "position": 2,
              "name": "Blog",
              "item": "https://www.primerehabindustries.in/blog"
            },
            {
              "@type": "ListItem",
              "position": 3,
              "name": "Advanced Hospital and Physiotherapy Equipment Manufacturer Chennai",
              "item": "https://www.primerehabindustries.in/blog/hospital-physiotherapy-equipment-manufacturer-chennai"
            }
          ]
        }
      ]
    };

    document.title = "Advanced Hospital Physiotherapy Equipment Manufacturer | Prime Rehab";

    let metaDesc = document.querySelector('meta[name="description"]');
    if (!metaDesc) {
      metaDesc = document.createElement('meta');
      metaDesc.name = "description";
      document.head.appendChild(metaDesc);
    }
    metaDesc.content = "Prime Rehab manufactures hospital and physiotherapy equipment in Chennai, trusted by 500+ clinics and hospitals with 1,000+ installations across India.";

    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.rel = "canonical";
      document.head.appendChild(canonical);
    }
    canonical.href = "https://www.primerehabindustries.in/blog/hospital-physiotherapy-equipment-manufacturer-chennai";

    let script = document.querySelector('#blog-schema');
    if (!script) {
      script = document.createElement('script');
      script.id = 'blog-schema';
      script.type = 'application/ld+json';
      document.head.appendChild(script);
    }
    script.innerHTML = JSON.stringify(schema);

    return () => {};
  }, []);

  return (
    <div className="hosp-layout">
      <Navbar />

      {/* Hero Section */}
      <section className="hosp-hero">
        <div className="hosp-container">
          <div className="hosp-hero-inner">
            <div className="hosp-hero-content">
              <span className="hosp-hero-tag">Hospital Grade Solutions</span>
              <h1>Advanced Hospital & Physiotherapy Equipment Manufacturer Chennai</h1>
              <p>
                Engineered for high patient volume, clinical durability, and therapist efficiency. Direct factory solutions for complete hospital rehabilitation departments.
              </p>
              <div style={{ display: 'flex', gap: '16px' }}>
                <a href="/contact" className="hosp-btn">Request Department Quote</a>
                <a href="tel:+919994351947" className="hosp-btn" style={{ background: 'transparent', border: '2px solid var(--hosp-primary)', color: 'var(--hosp-primary)' }}>+91 99943 51947</a>
              </div>
            </div>
            <div className="hosp-hero-image">
              <img src="https://primerehabindustries.in/Image/Product/Pro1.png" alt="Spinethera DTS Table by Prime Rehab Industries — Advanced hospital and physiotherapy equipment manufacturer in Chennai" />
            </div>
          </div>
        </div>
      </section>

      {/* Metric Strip */}
      <div className="hosp-metrics">
        <div className="hosp-container">
          <div className="hosp-metrics-grid">
            <div className="metric-item">
              <span className="metric-num">12+</span>
              <span className="metric-label">Years of Manufacturing</span>
            </div>
            <div className="metric-item">
              <span className="metric-num">100+</span>
              <span className="metric-label">Equipment Models</span>
            </div>
            <div className="metric-item">
              <span className="metric-num">500+</span>
              <span className="metric-label">Clinics & Hospitals</span>
            </div>
            <div className="metric-item">
              <span className="metric-num">1000+</span>
              <span className="metric-label">Installations</span>
            </div>
          </div>
        </div>
      </div>

      {/* Intro Section */}
      <section className="hosp-section">
        <div className="hosp-container">
          <div className="hosp-info-grid">
            <div className="hosp-info-text">
              <h3>What Hospital-Grade Actually Means</h3>
              <p>
                A table in a hospital outpatient department could be adjusted 50 times per day across back-to-back sessions. This demands higher duty cycles and heavier patient loads.
              </p>
              <p>
                Prime Rehab specifies components for clinical duty from the outset. Our motorised tables are built to handle hospital-volume use without the premature actuator wear that affects lighter clinic equipment.
              </p>
            </div>
            <div className="hosp-info-image">
              <img src="https://primerehabindustries.in/Image/Product/Pro2.png" alt="Hospital Grade Physiotherapy Equipment — Prime Rehab Chennai" />
            </div>
          </div>
        </div>
      </section>

      {/* Standards Section */}
      <section className="hosp-section" style={{ backgroundColor: '#f8fafc' }}>
        <div className="hosp-container">
          <div className="hosp-section-header">
            <h2>Clinical Manufacturing Standards</h2>
            <div className="hosp-accent-bar"></div>
          </div>
          <div className="hosp-std-grid">
            <div className="hosp-std-card">
              <h4>Higher Duty Cycles</h4>
              <p>Actuators rated for continuous hospital use, ensuring height adjustment mechanisms remain reliable under heavy daily caseloads.</p>
            </div>
            <div className="hosp-std-card">
              <h4>Multi-Dept Handover</h4>
              <p>Intuitive controls and standardized safety features (locking wheels, harness clips) that work reliably regardless of the operating therapist.</p>
            </div>
            <div className="hosp-std-card">
              <h4>Clinical Upholstery</h4>
              <p>Clinical-grade rexine selected for repeated disinfection with hospital-grade cleaners without surface degradation.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonial 1 */}
      <section className="hosp-quote">
        <div className="hosp-container">
          <div className="hosp-quote-inner">
            <blockquote>"We equipped our hospital physiotherapy department with treatment tables and a traction unit from Prime Rehab. The equipment handles a busy inpatient caseload without any problems. The motorised height adjustment is something our therapists rely on daily."</blockquote>
            <cite>— Arjun Krishnaswamy, Physiotherapy Dept Head, Vellore</cite>
          </div>
        </div>
      </section>

      {/* Range Section */}
      <section className="hosp-section">
        <div className="hosp-container">
          <div className="hosp-section-header">
            <h2>Hospital Product Range</h2>
            <p>From day surgery units to dedicated inpatient wards.</p>
          </div>
          <div className="hosp-std-grid">
            <div className="hosp-std-card">
              <h4 style={{ color: 'var(--hosp-accent)' }}>Orthopaedic Units</h4>
              <p>SPINETHERA DTS Table and High Low Traction Tables with adjustable backrests for spinal decompression and mobilisation.</p>
            </div>
            <div className="hosp-std-card">
              <h4 style={{ color: 'var(--hosp-accent)' }}>Neurological Wards</h4>
              <p>Wide High Low Bobath Tables (height from 48cm) and motorised Unweighing Systems for gait and neurodevelopmental therapy.</p>
            </div>
            <div className="hosp-std-card">
              <h4 style={{ color: 'var(--hosp-accent)' }}>Outpatient Physio</h4>
              <p>Motorised 3-Fold and 2-Fold treatment tables with remote operation, built for high-throughput therapy bays.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonial 2 */}
      <section className="hosp-quote">
        <div className="hosp-container">
          <div className="hosp-quote-inner">
            <blockquote>"The Spinethera DTS Table we ordered for our orthopaedic unit has performed beyond expectations. It handles high patient throughput consistently and the traction lock mechanism is smooth and reliable session after session."</blockquote>
            <cite>— Dr. Anitha Mohan, Senior Orthopaedic Physiotherapist, Erode</cite>
          </div>
        </div>
      </section>

      {/* Planning Section */}
      <section className="hosp-section" style={{ backgroundColor: '#0f172a', color: '#fff' }}>
        <div className="hosp-container">
          <div className="hosp-section-header">
            <h2 style={{ color: '#fff' }}>Department Planning Considerations</h2>
          </div>
          <div className="hosp-std-grid">
            <div className="hosp-std-card" style={{ background: 'rgba(255,255,255,0.05)', color: '#fff', border: '1px solid rgba(255,255,255,0.1)' }}>
              <h4 style={{ color: 'var(--hosp-accent)' }}>Bay Management</h4>
              <p style={{ opacity: 0.8 }}>Each bay typically requires one motorised table. Match the number of bays to your expected daily patient volume.</p>
            </div>
            <div className="hosp-std-card" style={{ background: 'rgba(255,255,255,0.05)', color: '#fff', border: '1px solid rgba(255,255,255,0.1)' }}>
              <h4 style={{ color: 'var(--hosp-accent)' }}>Stability Features</h4>
              <p style={{ opacity: 0.8 }}>Prioritize models with lockable wheels and harness systems for safe inpatient transfers and positioning.</p>
            </div>
            <div className="hosp-std-card" style={{ background: 'rgba(255,255,255,0.05)', color: '#fff', border: '1px solid rgba(255,255,255,0.1)' }}>
              <h4 style={{ color: 'var(--hosp-accent)' }}>Single-Source Supply</h4>
              <p style={{ opacity: 0.8 }}>Sourcing your entire department from one manufacturer simplifies procurement and ensures consistent build standards.</p>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="hosp-section">
        <div className="hosp-container">
          <div className="hosp-section-header">
            <h2>Frequently Asked Questions</h2>
          </div>
          <div className="hosp-faq-list">
            <div className="hosp-faq-item">
              <h5>What makes equipment suitable for hospital use?</h5>
              <p>Higher patient throughput demands heavier steel frames, higher-rated electric actuators, and upholstery that resists degradation under frequent clinical disinfection.</p>
            </div>
            <div className="hosp-faq-item">
              <h5>Can you supply a complete hospital department?</h5>
              <p>Yes. We regularly supply entire department setups covering treatment, traction, tilt, Bobath, and gait training systems in a single order.</p>
            </div>
            <div className="hosp-faq-item">
              <h5>Do you offer bulk pricing for hospitals?</h5>
              <p>We work directly with hospitals on department-level procurement. Pricing is based on the specific configuration and volume of equipment required.</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="hosp-section" style={{ background: 'linear-gradient(135deg, var(--hosp-primary), var(--hosp-accent))', color: '#fff', textAlign: 'center' }}>
        <div className="hosp-container">
          <h2 style={{ fontSize: '2.5rem', marginBottom: '24px', fontWeight: '900' }}>Equipping a Hospital Rehabilitation Department?</h2>
          <p style={{ fontSize: '1.2rem', marginBottom: '40px', opacity: 0.9 }}>Talk to our team about patient volume, therapy protocols, and space requirements. Get factory pricing on your complete setup.</p>
          <a href="/contact" className="hosp-btn-main" style={{ padding: '16px 40px', background: '#fff', color: 'var(--hosp-primary)', borderRadius: '4px', textDecoration: 'none', fontWeight: '900', display: 'inline-block' }}>Get Department Quote</a>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default AdvancedHospitalChennai;
